import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress"; // Optional if you're using jelly loader only
import "../../../styles/Backdrop.css";

const BackdropLoader = ({ open }) => {
  return (
    <main style={{ gridArea: "main", position: "relative" }}>
      <Backdrop
        sx={{
          position: "absolute", // Not fixed
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(10px)",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
      >
        <div>
          <div className="jelly-triangle">
            <div className="jelly-triangle__dot"></div>
            <div className="jelly-triangle__traveler"></div>
          </div>
          <svg width="0" height="0" className="jelly-maker">
            <defs>
              <filter id="uib-jelly-triangle-ooze">
                <feGaussianBlur
                  in="SourceGraphic"
                  stdDeviation="7.3"
                  result="blur"
                ></feGaussianBlur>
                <feColorMatrix
                  in="blur"
                  mode="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                  result="ooze"
                ></feColorMatrix>
                <feBlend in="SourceGraphic" in2="ooze"></feBlend>
              </filter>
            </defs>
          </svg>
        </div>
      </Backdrop>
    </main>
  );
};

export default BackdropLoader;
